import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  Step,
  StepHeading,
  StepContent,
  Label,
  Input,
  SettingsCollapse,
  StepOptionCard,
  Button,
  Select,
  InputGroup,
  PlusButton,
  ModalSummary,
  ModalAdditionalSummary,
  ModalAdditionalSummaryTitle,
  PercentageInput,
  CurrencyInput,
} from 'prospect-path-components';
import { connect } from 'react-redux';
import upperFirst from 'lodash/upperFirst';
import first from 'lodash/first';
import cloneDeep from 'lodash/cloneDeep';

import ErrorText from '../../ErrorText';

const Row = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
`;

class PlanPricingStep extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSettingsOpen: false,
      expandCost: false,
      initialCost: {
        name: '',
        type: '',
        amount: 0,
        period: '',
        per: '',
        primary: false,
        first_occurrence_offset: 0,
        first_occurrence_offset_period: 'MONTHLY',
      },
      data: {
        name: '',
        currency: '',
        primaryCost: {
          amount: 0,
          annual_discount: false,
          annual_discount_type: '',
          annual_discount_amount: '',
          period: '',
          per: '',
          primary: true,
          first_occurrence_offset: 0,
          first_occurrence_offset_period: 'MONTHLY',
        },
        costs: [],
      },
    };

    this.toggleAdvancedSettings = this.toggleAdvancedSettings.bind(this);
    this.toggleAnnualDiscountCard = this.toggleAnnualDiscountCard.bind(this);
    this.toggleCostCard = this.toggleCostCard.bind(this);
    this.addCost = this.addCost.bind(this);
    this.deleteCost = this.deleteCost.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePrimaryCostChange = this.handlePrimaryCostChange.bind(this);
    this.handleBillingPeriodChange = this.handleBillingPeriodChange.bind(this);
    this.handleNextButtonClicked = this.handleNextButtonClicked.bind(this);
    this.errorsForField = this.errorsForField.bind(this);
    this.errorsForCost = this.errorsForCost.bind(this);
  }
  componentWillMount() {
    const { pricing, plan } = this.props;

    if (Object.keys(pricing).length > 0) {
      const {
        currencies, licenseables, periods, discount_types,
      } = pricing;
      const { initialCost, data } = this.state;
      const { costs } = data;

      data.currency = first(Object.keys(currencies));
      data.primaryCost.per = first(Object.keys(licenseables));
      data.primaryCost.period = first(Object.keys(periods));
      data.primaryCost.annual_discount_type = first(Object.keys(discount_types));

      initialCost.per = first(Object.keys(licenseables));
      initialCost.period = first(Object.keys(periods));

      costs.push(initialCost);
      data.costs = costs;

      this.setState({
        data,
        initialCost,
      });
    }

    if (plan) {
      const { name, currency, costs } = plan;
      const { data } = this.state;
      const primary = costs.find(cost => cost.primary === true);
      const planCosts = costs.filter(cost => cost.primary !== true);
      const expandCost = planCosts.length > 0;
      const advancedSettingsOpen = primary.annual_discount || expandCost;

      data.name = name;
      data.currency = currency;
      data.primaryCost = primary;
      data.costs = planCosts.length > 0 ? planCosts : [cloneDeep(this.state.initialCost)];

      this.setState({ data, expandCost, advancedSettingsOpen });
    }
  }
  handleNextButtonClicked() {
    const data = cloneDeep(this.state.data);
    const {
      name, currency, primaryCost, costs,
    } = data;
    const updatedCosts = this.state.expandCost ? costs : [];

    primaryCost.annual_discount_amount = primaryCost.period === 'MONTHLY' && primaryCost.annual_discount ? primaryCost.annual_discount_amount : 0;

    updatedCosts.unshift(primaryCost);

    this.props.onNextButtonClicked({ name, currency, costs: updatedCosts });
  }
  toggleAdvancedSettings() {
    this.setState({ advancedSettingsOpen: !this.state.advancedSettingsOpen });
  }
  toggleAnnualDiscountCard() {
    const { data } = this.state;
    data.primaryCost.annual_discount = !this.state.data.primaryCost.annual_discount;

    this.setState({ data });
  }
  toggleCostCard() {
    this.setState({ expandCost: !this.state.expandCost });
  }
  getValueForSelectedData(data, selected) {
    return upperFirst(data[selected]);
  }
  getLicenseables() {
    const licenseables = this.props.pricing.licenseables || {};

    return Object.entries(licenseables).map(licenseable => ({
      value: licenseable[0],
      text: upperFirst(licenseable[1]),
    }));
  }
  transformPricingData(data) {
    data = data || {};

    return Object.entries(data).map(dataValue => ({
      value: dataValue[0],
      text: dataValue[1],
    }));
  }
  addCost() {
    const { initialCost, data } = this.state;
    const { costs } = data;

    costs.push(initialCost);

    data.costs = costs;

    this.setState({ data });
  }
  deleteCost(index) {
    const { data } = this.state;
    const { costs } = data;

    data.costs = costs.filter((additionalCost, costIndex) => costIndex !== index);

    this.setState({ data });
  }
  handleChange(e) {
    const { data } = { ...this.state };
    const { name, value } = e.target;
    data[name] = value;

    this.setState({ data });
  }
  handlePrimaryCostChange(e) {
    const { data } = { ...this.state };
    const { name, value } = e.target;
    data.primaryCost[name] = value;
    if (name === 'amount' && value != 0 && value !== '') {
      data.primaryCost[name] = Math.floor((parseFloat(value) + Number.EPSILON) * 100) / 100;
    }

    this.setState({ data });
  }
  handleBillingPeriodChange(e) {
    const { name, value } = e.target;
    const { data } = { ...this.state };
    data.annual_discount = e.value === 'MONTHLY';
    data.primaryCost[name] = value;

    this.setState({ data });
  }
  handleCostsChange(e, index) {
    const { name, value } = e.target;
    const { data } = { ...this.state };
    const { costs } = data;
    const costIndex = costs.findIndex((additionalCost, additionalCostsIndex) => additionalCostsIndex === index);
    const cost = { ...costs[costIndex] };
    cost[name] = value;
    if (name === 'amount' && value != 0 && value !== '') {
      cost[name] = Math.floor((parseFloat(value) + Number.EPSILON) * 100) / 100;
    }

    costs.splice(costIndex, 1, cost);

    this.setState({ data });
  }
  errorsForField(field) {
    if (this.props.errors[field]) {
      return this.props.errors[field].map(error => <ErrorText>{error}</ErrorText>);
    }

    return '';
  }
  errorsForCost(index, field) {
    if (this.props.errors.costs && this.props.errors.costs.hasOwnProperty(index)) {
      const costErrors = this.props.errors.costs[index];

      if (costErrors !== undefined && costErrors[field]) {
        return costErrors[field].map(error => <ErrorText style={{ display: 'block' }}>{error}</ErrorText>);
      }
    }

    return '';
  }
  render() {
    return (
      <Step>
        <StepHeading
          number={1}
          disabled={this.props.disabled}
          showEditButton={this.props.showEditButton}
          onEditButtonClicked={this.props.onEditButtonClicked}
        >
          Plan Pricing
        </StepHeading>

        {!this.props.isOpened && (
          <ModalSummary>
            <div>{this.state.data.name}</div>
            <div>
              {this.state.data.primaryCost.amount} ({this.state.data.currency}) per&nbsp;
              {this.getValueForSelectedData(this.props.pricing.licenseables, this.state.data.primaryCost.per)},&nbsp;
              {this.getValueForSelectedData(this.props.pricing.periods, this.state.data.primaryCost.period)}
            </div>

            {this.state.expandCost && (
              <div>
                {this.state.data.costs.map((cost, index) => (
                  <ModalAdditionalSummary key={index}>
                    <ModalAdditionalSummaryTitle>Additional Cost</ModalAdditionalSummaryTitle>
                    <div>{cost.name}</div>
                    <div>
                      {cost.amount} ({this.state.data.currency}) per&nbsp;
                      {this.getValueForSelectedData(this.props.pricing.licenseables, cost.per)},&nbsp;
                      {this.getValueForSelectedData(this.props.pricing.periods, cost.period)}
                    </div>
                  </ModalAdditionalSummary>
              ))}
              </div>
            )}
          </ModalSummary>
        )}

        <StepContent isOpened={this.props.isOpened}>
          <Row>
            <InputGroup fullWidth>
              {this.errorsForField('name')}
              <Label>Plan Name</Label>
              <Input
                highlighted
                block
                name="name"
                value={this.state.data.name}
                onChange={this.handleChange}
                disabled={this.props.readOnly}
              />
            </InputGroup>
          </Row>

          {this.errorsForCost(0, 'amount')}
          {this.errorsForField('currency')}
          {this.errorsForCost(0, 'per')}
          {this.errorsForCost(0, 'period')}
          <Row>
            <InputGroup horizontal style={{ flex: 1 }}>
              <Label>Cost</Label>
              <Input
                name="amount"
                type="number"
                step="00.01"
                min="00.00"
                value={this.state.data.primaryCost.amount}
                onChange={this.handlePrimaryCostChange}
                disabled={this.props.readOnly}
              />
            </InputGroup>

            <InputGroup horizontal style={{ flex: 1 }}>
              <Label>Currency</Label>
              <Select
                name="currency"
                value={this.state.data.currency}
                onChange={this.handleChange}
                disabled={this.props.readOnly}
              >
                {this.transformPricingData(this.props.pricing.currencies).map(({ text, value }) => (
                  <option key={value} value={value}>{text}</option>
                ))}
              </Select>
            </InputGroup>

            <InputGroup horizontal style={{ flex: 1 }}>
              <Label>Per</Label>
              <Select
                name="per"
                value={this.state.data.primaryCost.per}
                onChange={this.handlePrimaryCostChange}
                disabled={this.props.readOnly}
              >
                {this.getLicenseables().map(({ text, value }) => (
                  <option key={value} value={value}>{text}</option>
                ))}
              </Select>
            </InputGroup>

            <InputGroup horizontal style={{ flex: 1 }}>
              <Label>Billing Period</Label>
              <Select
                name="period"
                value={this.state.data.primaryCost.period}
                onChange={this.handleBillingPeriodChange}
                disabled={this.props.readOnly}
              >
                {this.transformPricingData(this.props.pricing.periods).map(({ text, value }) => (
                  <option key={value} value={value}>{text}</option>
                ))}
              </Select>
            </InputGroup>
          </Row>

          <SettingsCollapse
            isOpened={this.state.advancedSettingsOpen}
            label="Show advanced settings"
            onClick={this.toggleAdvancedSettings}
          >
            <div style={{ marginBottom: '0.75rem' }}>
              {this.errorsForCost(0, 'annual_discount_amount')}
              {this.errorsForCost(0, 'annual_discount_type')}
              <StepOptionCard
                title="Annual Discount"
                switchLabel={this.state.data.primaryCost.period !== 'MONTHLY' ? 'Applicable to monthly plans only' : null}
                showSwitch
                switchProps={{
                  onChange: this.toggleAnnualDiscountCard,
                  checked: this.state.data.primaryCost.annual_discount,
                  disabled: this.state.data.primaryCost.period !== 'MONTHLY',
                }}
                isOpened={this.state.data.primaryCost.period === 'MONTHLY' && this.state.data.primaryCost.annual_discount}
              >
                <Row>
                  <InputGroup horizontal style={{ flex: 1 }}>
                    <Label>Value</Label>
                    {this.state.data.primaryCost.annual_discount_type === 'PERCENT' && (
                      <PercentageInput
                        name="annual_discount_amount"
                        type="number"
                        max="100"
                        min="0"
                        block
                        onChange={this.handlePrimaryCostChange}
                        value={this.state.data.primaryCost.annual_discount_amount}
                        disabled={this.props.readOnly}
                      />
                    )}
                    {this.state.data.primaryCost.annual_discount_type === 'AMOUNT' && (
                      <CurrencyInput
                        type="number"
                        symbol={this.getValueForSelectedData(this.props.pricing.currencies, this.state.data.currency)}
                        min="0"
                        step="0.01"
                        block
                        onChange={this.handlePrimaryCostChange}
                        name="annual_discount_amount"
                        value={this.state.data.primaryCost.annual_discount_amount}
                        disabled={this.props.readOnly}
                      />
                    )}
                  </InputGroup>
                  <InputGroup horizontal style={{ flex: 1 }}>
                    <Label>
                      Type
                    </Label>
                    <Select
                      value={this.state.data.primaryCost.annual_discount_type}
                      name="annual_discount_type"
                      onChange={this.handlePrimaryCostChange}
                      disabled={this.props.readOnly}
                    >
                      {this.transformPricingData(this.props.pricing.discount_types).map(({ text, value }) => (
                        <option key={value} value={value}>{text}</option>
                      ))}
                    </Select>
                  </InputGroup>
                </Row>
              </StepOptionCard>
            </div>
            <div>
              {this.state.data.costs.map((additionalCost, index) => (
                <StepOptionCard
                  key={index}
                  title={index === 0 ? 'Additional Costs' : null}
                  isOpened={this.state.expandCost}
                  switchProps={{ onChange: this.toggleCostCard, checked: this.state.expandCost }}
                  showSwitch={index === 0}
                  style={{ display: (index === 0 || this.state.expandCost) ? 'block' : 'none' }}
                  showRemoveButton={index !== 0}
                  onRemoveButtonClicked={() => this.deleteCost(index)}
                >
                  {this.errorsForCost(index + 1, 'name')}
                  {this.errorsForCost(index + 1, 'type')}
                  <Row>
                    <InputGroup horizontal style={{ flex: 1 }}>
                      <Label>Cost Name</Label>
                      <Input
                        name="name"
                        highlighted
                        block
                        type="text"
                        value={this.state.data.costs[index].name}
                        disabled={this.props.readOnly}
                        onChange={(e) => {
                          this.handleCostsChange(e, index);
                        }}
                      />
                    </InputGroup>
                    {/*<InputGroup horizontal style={{ flex: 1 }}>*/}
                    {/*  <Label>Type</Label>*/}
                    {/*  <Select disabled={this.props.readOnly}>*/}
                    {/*    <option />*/}
                    {/*  </Select>*/}
                    {/*</InputGroup>*/}
                  </Row>
                  {this.errorsForCost(index + 1, 'amount')}
                  {this.errorsForCost(index + 1, 'currency')}
                  {this.errorsForCost(index + 1, 'per')}
                  {this.errorsForCost(index + 1, 'period')}
                  <Row>
                    <InputGroup horizontal style={{ flex: 1 }}>
                      <Label>Cost</Label>
                      <Input
                        type="number"
                        name="amount"
                        min="0"
                        step="0.01"
                        value={this.state.data.costs[index].amount}
                        onChange={e => this.handleCostsChange(e, index)}
                        disabled={this.props.readOnly}
                      />
                    </InputGroup>

                    <InputGroup horizontal style={{ flex: 1 }}>
                      <Label>Currency</Label>
                      <Select
                        value={this.state.data.currency}
                        disabled
                      >
                        {this.transformPricingData(this.props.pricing.currencies).map(({ text, value }) => (
                          <option key={value} value={value}>{text}</option>
                        ))}
                      </Select>
                    </InputGroup>

                    <InputGroup horizontal style={{ flex: 1 }}>
                      <Label>Per</Label>
                      <Select
                        value={this.state.data.costs[index].per}
                        name="per"
                        onChange={e => this.handleCostsChange(e, index)}
                        disabled={this.props.readOnly}
                      >
                        {this.getLicenseables().map(({ text, value }) => (
                          <option key={value} value={value}>{text}</option>
                        ))}
                      </Select>
                    </InputGroup>

                    <InputGroup horizontal style={{ flex: 1 }}>
                      <Label>Billing Period</Label>
                      <Select
                        value={this.state.data.costs[index].period}
                        name="period"
                        onChange={e => this.handleCostsChange(e, index)}
                        disabled={this.props.readOnly}
                      >
                        {this.transformPricingData(this.props.pricing.periods).map(({ text, value }) => (
                          <option key={value} value={value}>{text}</option>
                        ))}
                      </Select>
                    </InputGroup>
                  </Row>
                </StepOptionCard>
              ))}
            </div>

            {this.state.expandCost && <PlusButton disabled={this.props.readOnly} onClick={this.addCost}>Add Additional Cost</PlusButton>}
          </SettingsCollapse>

          <div style={{ marginTop: '1.25rem' }}>
            <Button
              color="secondary"
              onClick={this.handleNextButtonClicked}
            >
              Continue
            </Button>
          </div>
        </StepContent>
      </Step>

    );
  }
}

PlanPricingStep.propTypes = {
  isOpened: PropTypes.bool,
  disabled: PropTypes.bool,
  onNextButtonClicked: PropTypes.func.isRequired,
  showEditButton: PropTypes.bool,
  onEditButtonClicked: PropTypes.func,
  errors: PropTypes.object,
  readOnly: PropTypes.bool,
};

PlanPricingStep.defaultProps = {
  isOpened: false,
  disabled: true,
  showEditButton: false,
  onEditButtonClicked: () => {},
  errors: {},
  readOnly: false,
};

const mapStateToProps = state => ({
  pricing: state.productManagement.pricing.all,
});

export default connect(mapStateToProps)(PlanPricingStep);
